export function setBuildVersion(versionNamespace = 'TDS_VERSION') {
  try {
    window[versionNamespace] = process.env.BUILD_VERSION;
  } catch (e) {
    window[versionNamespace] = 'failed to set version';
  }
}
